import * as Sentry from "@sentry/nextjs"
import { XError } from "@/utils/error.utils"

export type ClientReportTags = { surface: string; action?: string } & Record<
    string,
    string
>

export type ClientReportParams = {
    message: string
    cause?: Error | Error[] | null
    data?: unknown
    tags: ClientReportTags
}

const sentryExtra = (
    data: unknown
): { extra: { data: unknown } } | Record<string, never> =>
    data === undefined ? {} : { extra: { data } }

export const reportClientWarning = ({
    tags,
    ...params
}: ClientReportParams): XError => {
    const err = new XError(params)
    Sentry.captureException(err, {
        level: "warning",
        tags,
        ...sentryExtra(params.data),
    })
    return err
}

export const reportClientError = ({
    tags,
    ...params
}: ClientReportParams): XError => {
    const err = new XError(params)
    Sentry.captureException(err, {
        level: "error",
        tags,
        ...sentryExtra(params.data),
    })
    return err
}
